import { ProductRecommendationResponseSchema } from '@/schemas/catalog/catalogSchemas'
import { type IProductCard } from '@/schemas/catalog/product'
import { api, apiService } from '@/services/core/ApiService'

/**
 * Recomendações (rotas do `CartController`, servidas por um motor de IA externo). São opcionais na tela: qualquer
 * falha vira lista vazia, sem toast.
 */

// ===== DO CLIENTE (GET cart/product-user-recomendation/{customerId}) =====

/** Recomendados para o cliente logado (PDP e carrinho). `customerId` é o id do cliente (o `nameid` do token). */
export const getCustomerRecommendationsService = (customerId: string): Promise<IProductCard[]> =>
    apiService(api)
        .get(`cart/product-user-recomendation/${encodeURIComponent(customerId)}`, ProductRecommendationResponseSchema)
        .onError(() => {}, { useDefaultErrorHandler: false, swallow: true })
        .execute()
        .then((data) => data?.products ?? [])

// ===== POR PRODUTOS (POST cart/product-recomendation) =====

/** Relacionados a uma lista de produtos (carrinho do visitante sem login). Sem ids, `[]` sem chamar a API. */
export const getRelatedProductsService = (productIds: string[]): Promise<IProductCard[]> => {
    if (productIds.length === 0) return Promise.resolve([])
    return apiService(api)
        .post('cart/product-recomendation', productIds, ProductRecommendationResponseSchema)
        .onError(() => {}, { useDefaultErrorHandler: false, swallow: true })
        .execute()
        .then((data) => data?.products ?? [])
}
